function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import Input from '../Input';
import FormControlLabel from '../FormControlLabel';
import FormattedInputCurrency from './FormattedInputCurrency';
export var FormControlTextField = function FormControlTextField(_ref) {
  var label = _ref.label,
      labelPlacement = _ref.labelPlacement,
      leftAdornment = _ref.leftAdornment,
      format = _ref.format,
      width = _ref.width,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["label", "labelPlacement", "leftAdornment", "format", "width", "disabled"]);

  var formatProps;

  if (format === 'Currency') {
    formatProps = {
      inputComponent: FormattedInputCurrency
    };
  }

  return /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Input, Object.assign({
      style: {
        width: width
      },
      disabled: disabled
    }, formatProps, omit(rest, 'renderFormControl'))),
    label: label,
    labelPlacement: labelPlacement,
    leftAdornment: leftAdornment,
    error: rest.error,
    gutterBottom: true
  });
};
export var propTypes = {
  error: PropTypes.bool,
  format: PropTypes.oneOf(['Text', 'Currency', 'Number', 'Decimal', 'Percent']),
  helperText: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string
};
FormControlTextField.defaultProps = {
  width: 300
};
FormControlTextField.propTypes = propTypes;
export default FormControlTextField;